import React, { useState } from 'react';
import './Gallery.css';

const Gallery = ({ images }) => {
  // State to manage the selected large image
  const [selectedImage, setSelectedImage] = useState(images[0]);

  // Function to handle the click on a thumbnail
  const handleThumbnailClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  return (
    <div className="gallery-container">      
      {/* Large selected image */}
      <div className="selected-image">
        <img src={selectedImage} alt="Selected" />
      </div>

      {/* Thumbnails of the other images */}
      <div className="thumbnails">
        {images.map((imageUrl, index) => (
          <div
            key={index}
            className="thumbnail"
            onClick={() => handleThumbnailClick(imageUrl)}
          >
            <img src={imageUrl} alt={`Thumbnail ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
